import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableWorks from "./components/TableWork";


function WorkRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableWorks />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default WorkRegisterPage;